import { z } from 'zod';
export const APPOINTMENT_KINDS = ['evaluation', 'consultation', 'follow_up', 'block', 'surgery'];
export const APPOINTMENT_STATUSES = ['scheduled', 'confirmed', 'checked_in', 'completed', 'no_show', 'cancelled'];
/** Duração padrão por tipo (minutos). Configurável por clínica numa próxima etapa. */
export const DEFAULT_DURATION_MIN = {
    evaluation: 45, consultation: 30, follow_up: 20, block: 60, surgery: 480
};
export const professionalSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    title: z.string().nullable(),
    /** Dias da semana com atendimento (0 = domingo). */
    weekdays: z.array(z.number().int()),
    /** Faixas de atendimento em hora local ("08:00"). */
    hours: z.array(z.object({ weekday: z.number().int(), start: z.string(), end: z.string() })),
});
export const slotsResponseSchema = z.object({
    date: z.string(),
    professionals: z.array(z.object({ professionalId: z.uuid(), slots: z.array(z.string()) })),
});
export const appointmentSchema = z.object({
    id: z.uuid(),
    kind: z.enum(APPOINTMENT_KINDS),
    status: z.enum(APPOINTMENT_STATUSES),
    confirmation: z.enum(['pending', 'confirmed', 'reschedule_requested']),
    startsAt: z.string(),
    endsAt: z.string(),
    professional: z.object({ id: z.uuid(), name: z.string() }).nullable(),
    contact: z.object({ id: z.uuid(), name: z.string(), maskedPhone: z.string().nullable() }).nullable(),
    leadId: z.uuid().nullable(),
    conversationId: z.uuid().nullable(),
    cancelReason: z.string().nullable(),
    reminders: z.object({ h48: z.string().nullable(), h24: z.string().nullable() }),
    version: z.number().int(),
});
export const bookAppointmentSchema = z.object({
    contactId: z.uuid(),
    kind: z.enum(['evaluation', 'consultation', 'follow_up']).default('evaluation'),
    professionalId: z.uuid(),
    startsAt: z.iso.datetime({ offset: true }),
    /** Envia a confirmação no WhatsApp do paciente (padrão: sim). */
    notifyPatient: z.boolean().default(true),
});
export const updateAppointmentStatusSchema = z.object({
    status: z.enum(['confirmed', 'checked_in', 'completed', 'no_show', 'cancelled']),
    cancelReason: z.string().trim().min(2).max(200).optional(),
    version: z.number().int(),
}).refine((v) => v.status !== 'cancelled' || !!v.cancelReason, { message: 'Informe o motivo do cancelamento', path: ['cancelReason'] });
export const rescheduleSchema = z.object({
    startsAt: z.iso.datetime({ offset: true }),
    professionalId: z.uuid().optional(),
    version: z.number().int(),
    notifyPatient: z.boolean().default(true),
});
//# sourceMappingURL=scheduling.js.map